import { ArrowUpRight, Code2 } from "lucide-react";
import { CALENDAR, SERVICES } from "./data";
import { Reveal } from "./Reveal";

export function Services() {
  return (
    <section className="services page-width" id="work" data-testid="services-section">
      <div className="section-heading">
        <div>
          <div className="section-kicker">How I can help</div>
          <h2>
            Useful in the
            <br />
            messy middle.
          </h2>
        </div>
        <p>
          Not just a pair of hands. A senior engineer who can go from “we should probably…” to a
          working product, with enough product sense to know what matters.
        </p>
      </div>
      <div className="bento">
        {SERVICES.map((service, i) => (
          <Reveal
            className="bento-card"
            delay={i * 0.09}
            key={service.icon}
            data-testid={`service-card-${service.icon}`}
          >
            <span className="service-number">{service.icon}</span>
            <Code2 size={21} />
            <h3>{service.title}</h3>
            <p>{service.copy}</p>
            {service.capabilities && (
              <div className="capability-list">
                {service.capabilities.map((cap) => (
                  <span key={cap}>{cap}</span>
                ))}
              </div>
            )}
            <a
              href={CALENDAR}
              target="_blank"
              rel="noreferrer"
              className="card-link"
              data-testid={`service-book-link-${service.icon}`}
            >
              Let’s discuss <ArrowUpRight size={15} />
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
